const getPlanValueStatus = (role, finAccess, editCheck, value) => {
  if (role === 'Full control' && finAccess === 'READ' && editCheck !== 'plan') {
    return value;
  }
  if (role === 'Full control' && finAccess === 'none') {
    return null;
  }
  return value;
};

export const getFixedCostValuesStatus = getPlanValueStatus;

export const getProjectedRevenueValuesStatus = getPlanValueStatus;
